<template>
  <el-dialog :visible.sync="cusVisible" custom-class="wxChat_Cus" title="" width="400px">
    <div class="wxChat_top">
      <img :src="require('@/assets/image/chat/wx_system.png')">
      {{ customer_describe }}
    </div>
    <div class="wxChat_btn" @click="goCuser">联系客服</div>
  </el-dialog>
</template>

<script>
import {apiGetCustomerQrcodeInfo} from "@/request/API";
export default {
  name: 'goCusSerCenter',
  data() {
    return {
      cusVisible: false,
      customer_describe: '',
    }
  },
  created() {
    apiGetCustomerQrcodeInfo().then(res =>{
      if(res.data.customer_qr_code_flag == 1){
        this.customer_describe = res.data.customer_describe
        this.cusVisible = true
      }
    })
  },
  methods: {
    goCuser() {
      this.$router.push({name: 'CusSerCenter'})
    },
  },
}
</script>

<style lang="less">
.wxChat_Cus{
  border-radius: 4px !important;
  padding: 0;
  .el-dialog__header {
    // display: none;
    padding: 0;
    .el-dialog__headerbtn{
      top: 10px;
      right: 10px;
      font-size: 20px;
    }
  }
  .el-dialog__body {
    padding: 0 0 40px !important;
    background: transparent;
  }
  .wxChat_top{
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    font-size: 16px;
    font-family: PingFang SC-Medium, PingFang SC;
    font-weight: 500;
    color: #A3A3A3;
    padding: 27px 0 0;
    max-width: 272px;
    margin: 0 auto;
  }
  .wxChat_btn{
    width: 312px;
    height: 45px;
    background: var(--primary, #FF5A1F);
    border-radius: 4px 4px 4px 4px;
    line-height: 45px;
    text-align: center;
    margin: 40px auto 0;
    font-size: 18px;
    font-family: PingFang SC-Medium, PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
    cursor: pointer;
  }
}
</style>